module.exports = __webpack_public_path__ + "static/media/detail_filter.c6767cac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/detail_filter.gif
// module id = 190
// module chunks = 0